import React from "react";
import { InputLabel, FormHelperText, Input, Chip, Grid, MenuItem } from "@material-ui/core";
import { FormikProps, Field } from "formik";

import { required } from "Tools/FormValidations";
import { STChipWrap, STFormControl, STSelect, STMenuItem, STIconGrid } from "./styles";
import { STDescriptionTypography } from "@src/Components/Ui/STDescriptionTypography";
import Check from "@material-ui/icons/Check";

interface IProps<T, ItemType> {
  formikProps: FormikProps<T>;
  fieldName: keyof T;
  keyAsTitle: keyof ItemType;
  keyAsValue: keyof ItemType;
  keyAsDescription?: keyof ItemType;
  keyAsOptionDisabled?: keyof ItemType;
  items: ItemType[];
  groupItems?: { possibilities: ItemType[]; title: string }[];
  isGroup?: boolean;
  label: string;
  onChange?: (event: any, formikProps: FormikProps<T>) => void;
  allowEmpty?: boolean;
}

class FormMultiselect<T, ItemType> extends React.Component<IProps<T, ItemType>> {
  handleChange = (event: any) => {
    this.props.onChange(event, this.props.formikProps);
  };

  getItemCheckedState = (item: ItemType) => {
    const foundedItem: string = this.props.formikProps.values[this.props.fieldName].find(
      (str: string | number) => str === item[this.props.keyAsValue]
    );

    return foundedItem;
  };

  render() {
    const formikProps: FormikProps<T> = this.props.formikProps;
    const keyAsDescription: string = (this.props.keyAsDescription as string) || "description";

    return (
      <Field
        name={this.props.fieldName}
        validate={this.props.allowEmpty ? null : required}
        render={() => (
          <STFormControl
            error={formikProps.touched[this.props.fieldName] && !!formikProps.errors[this.props.fieldName]}
          >
            <InputLabel htmlFor="select-multiple-chip">{this.props.label}</InputLabel>

            <STSelect
              multiple
              value={formikProps.values[this.props.fieldName] as any}
              onChange={this.props.onChange ? this.handleChange : formikProps.handleChange}
              input={<Input id="select-multiple-chip" name={this.props.fieldName as string} />}
              renderValue={(selected: any) => (
                <STChipWrap>
                  {this.props.items
                    .filter((item: ItemType) => selected.includes(item[this.props.keyAsValue]))
                    .map((value: ItemType) => {
                      return <Chip key={value[this.props.keyAsValue] as any} label={value[this.props.keyAsTitle]} disabled={value[this.props.keyAsOptionDisabled as string]} />;
                    })}
                </STChipWrap>
              )}
            >
              {!this.props.isGroup
                ? this.createList(this.props.items, keyAsDescription)
                : this.props.groupItems.map((group) => {
                    const items = this.createList(group.possibilities, keyAsDescription);
                    items.unshift(
                      <MenuItem disabled value="">
                        {group.title}
                      </MenuItem>
                    );
                    return items;
                  })}
            </STSelect>

            {formikProps.touched[this.props.fieldName] && formikProps.errors[this.props.fieldName] && (
              <FormHelperText>{formikProps.errors[this.props.fieldName]}</FormHelperText>
            )}
          </STFormControl>
        )}
      />
    );
  }

  createList = (items: ItemType[], keyAsDescription: string) =>
    items.map((item: ItemType, i: number) => (
      <STMenuItem disabled={item[this.props.keyAsOptionDisabled as string]} key={i} value={item[this.props.keyAsValue] as any} divider={item.divider as boolean}>
        <Grid container justify="flex-start">
          <STIconGrid item>{this.getItemCheckedState(item) && <Check />}</STIconGrid>
          <Grid item container direction="column" xs>
            <Grid item>{item[this.props.keyAsTitle] as any}</Grid>
            <Grid item>
              <STDescriptionTypography>{item[keyAsDescription]}</STDescriptionTypography>
            </Grid>
          </Grid>
        </Grid>
      </STMenuItem>
    ));
}

export default FormMultiselect;
